/** @file 答题卡 语言配置 */
const zhCN = {
  answerCard: {
    submit: '提交',
    ignoreTips: '忽略',
    endTips: '答题已结束',
    successTips: '已答题',
    submitSuccessTips: '提交成功',
    submitFailedTips: '提交失败',
    submitAnswer: '提交答案',
    singleChoice: '【单选】',
    multiChoice: '【多选】',
    pointsChoice: '【评分】',
    voteChoice: '【投票】',
    know: '我知道了',
    pointsClosed: '评分截止',
    pointsEnd: '评分已截止',
    averageScore: '平均得分',
    point: '分',
    rightAnswerWords: '恭喜您答对了',
    wrongAnswerWords: '抱歉您答错了',
    notSubmittedTips: '抱歉您未答题',
    notSubmittedTipsMobile: '未作答',
    people: '人',
    leftTime: '答题剩余时间',
    qaMobCloseBtn: '已截止',
    qaMobSubmitBtn: '提交',
    qaMobSubmitSuccessBtn: '已提交',
    qaIgnore: '忽略',
    qaEnd: '答题已结束',
    qaSuccess: '已答题',
    mobSubmitAnswer: '提交',
    checkResult: '查看结果',
  },
};

const en = {
  answerCard: {
    submit: 'Submit',
    ignoreTips: 'Ignore',
    endTips: 'End',
    successTips: 'Success',
    submitSuccessTips: 'Success',
    submitFailedTips: 'Submission Failed',
    submitAnswer: 'Submit',
    singleChoice: '【Single Choice】',
    multiChoice: '【Multiple Choice】',
    pointsChoice: '【Points】',
    voteChoice: '【Vote】',
    know: 'OK',
    pointsEnd: 'Rating stopped',
    averageScore: 'Average Score',
    point: '',
    rightAnswerWords: 'Congratulation, you are right! ',
    wrongAnswerWords: 'Sorry，wrong answer.',
    notSubmittedTips: 'Sorry， Question unanswered',
    people: '',
    leftTime: '',
    qaMobCloseBtn: 'Closed',
    qaMobSubmitBtn: 'Submit',
    qaMobSubmitSuccessBtn: 'Success',
    qaIgnore: 'Ignore',
    qaEnd: 'End',
    qaSuccess: 'Success',
    mobSubmitAnswer: 'Submit',
    checkResult: 'Result',
  },
  pushCard: {
    getNow: '立即领取',
    get: '领取',
    defaultCountdownMsg: '连续观看有奖励哦',
  },
};

export default {
  zh_CN: zhCN,
  en,
};
